import React, { useEffect } from "react";
import MainLayout from "@/components/layout/MainLayout";
import { motion } from "framer-motion";
import TeamCard from "@/components/TeamCard";
import { teamData } from "@/data/teamData";
import { CheckCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

const About = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const services = t('about.services', { returnObjects: true }) as string[];

  return (
    <MainLayout>
      <section className="pt-32 pb-24 bg-[#1A1A1A] text-[#D9D9D9]">
        <div className="mx-auto max-w-[1200px] px-4">
          <motion.h1
            className="text-4xl sm:text-5xl font-semibold font-poppins text-center mb-16"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            {t('about.title')}
          </motion.h1>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {teamData.map((member, index) => (
              <TeamCard key={index} {...member} />
            ))}
          </div>
        </div>
      </section>
      <section className="py-24 px-6 bg-[#1A1A1A] text-white">
        <h2 className="text-4xl font-bold text-white text-center mb-4">{t('about.managementTitle')}</h2>
        <p className="max-w-3xl mx-auto text-center text-neutral-400 mb-12">
          {t('about.managementIntro')}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4 max-w-6xl mx-auto">
          {services.map((service, index) => (
            <div key={index} className="flex items-start gap-3 py-2">
              <CheckCircle className="text-[#e45656] mt-1 flex-shrink-0" size={20} />
              <p className="text-neutral-300 text-lg md:text-xl transition-colors duration-300 hover:text-red-500">{service}</p>
            </div>
          ))}
        </div>

        <div className="bg-neutral-900 rounded-md shadow-md text-center mt-20 py-12 px-6 max-w-4xl mx-auto">
          <h3 className="text-2xl font-semibold mb-2 text-white">{t('about.ctaTitle')}</h3>
          <p className="text-neutral-300 mb-6 text-sm">{t('about.ctaText')}</p>
          <a
            href="/contact"
            className="inline-block bg-neutral-700 text-white px-6 py-2 rounded transition duration-300 hover:bg-red-600"
          >
            {t('about.ctaButton')}
          </a>
        </div>
      </section>
    </MainLayout>
  );
};

export default About;
